export default __webpack_public_path__ + "static/media/Pilule oestro progestative.d65626cc.jpg";